<template>
    <ValidationObserver ref="observer"
                        tag="form"
                        class="mx-2"
                        @submit.prevent="submit">
        <div class="row d-flex">
            <div class="col-sm-12 py-4">
                <div v-for="ovp in ovps" :key="ovp._id">
                    <div class="row text-center my-4">    
                        <ValidationProvider tag="div"
                                            class="col-sm-2 mb-4"
                                            vid="name"
                                            mode="lazy"
                                            :customMessages="{required: 'Norādi darba apstākļa nosaukumu.'}"
                                            rules="required"
                                            v-slot="{errors}">
                            <label for="name" class="d-block text-secondary text-left mb-0">Nosaukums</label>
                            <input type="text" id="name" class="w-100 py-1 ds-input" v-model="ovp.ovpJobCondition.globalOvpJobCondition.name" :disabled="true">
                            <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider tag="div"
                                            vid="period"
                                            class="col-sm-2 mb-4"
                                            mode="lazy"
                                            v-slot="{errors}">
                            <label class="d-block text-secondary text-left mb-0">Periods</label>
                            <input type="text" id="period" class="w-100 py-1 ds-input" v-model="ovp.formatedPeriod" :disabled="true">
                            <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                        </ValidationProvider>
                        
                        <ValidationProvider tag="div"
                            :vid="`${ovp.id}-actualInspectionDate`"
                            class="col-sm-3 mb-4"
                            mode="lazy"
                            v-slot="{errors}">
                            <label :for="`${ovp.id}-actualInspectionDate`" class="d-block text-secondary text-left mb-0">Iziešanas datums</label>
                            <b-form-datepicker :id="`${ovp.id}-actualInspectionDate`" class="ds-input" :value="actualInspectionDate" @context="ovp.nextInspectionDate = getNextInspectionDate(...arguments, ovp)" locale="lv" placeholder="Izvēlies datumu"/>
                            <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider tag="div"
                            :vid="`${ovp.id}-nextInspection`"
                            class="col-sm-2 mb-4"
                            mode="lazy"
                            v-slot="{errors}">
                            <label :for="`${ovp.id}-nextInspection`" class="d-block text-secondary text-left mb-0">Nākošās pārbaudes datums</label>
                            <b-form-datepicker :id="`${ovp.id}-nextInspection`" class="ds-input" v-model="ovp.nextInspectionDate" locale="lv" placeholder="Izvēlies datumu" :disabled="true"/>
                            <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                        </ValidationProvider>

                        <ValidationProvider
                            class="col-sm-3"
                            tag="div"
                            vid="docComment"
                            mode="lazy"
                            v-slot="{errors}">
                            <b-form-textarea
                                id="docComment"
                                v-model="ovp.doctorsComment"
                                placeholder="Ārsta komentārs"
                                rows="3"
                                max-rows="6"
                                ></b-form-textarea>
                            <span class="text-danger d-block text-left small mt-1">{{ errors[0] }}</span>
                        </ValidationProvider>
                    </div>
                    <hr/>
                </div>
            </div>
        </div>
        <CustomButton class="w-25 mb-4 ds-btn--success" btn-text="Saglabāt izmaiņas" :is-loading="isActiveRequest"/>
    </ValidationObserver>
</template>
<script>
    import {mapActions, mapGetters, mapMutations} from 'vuex';

    import _ from 'lodash'; 
    import {extend, ValidationObserver, ValidationProvider} from 'vee-validate';
    import {required} from 'vee-validate/dist/rules';
    import * as rootStoreTypes from '../../../vuex/root.store-types'
    import * as ovpStoreTypes from '../../../vuex/modules/ovp/ovp.store-types';
    import * as companyStoreTypes from '../../../vuex/modules/company/company.store-types';

    import CustomButton from '@/components/global/CustomButton';

    export default {
        name: 'user-ovp-job-condition-approve-base-form',
        components: {
            CustomButton,
            ValidationProvider,
            ValidationObserver,
        },
        props: {
            readyToBeApprovedOvps: {
                type: Array,
                required: true,
            },
        },
        data() {
            return {
                ovps: _.cloneDeep(this.readyToBeApprovedOvps),
                actualInspectionDate: new Date(),
            }
        },
        async created() {
            extend('required', required);

            this.ovps = this.ovps.map(ovp => {
                ovp.nextInspectionDate = new Date(new Date().setFullYear(new Date().getFullYear() + (+ovp.ovpJobCondition.period)));
                
                return ovp;
            })
        },
        computed: {
            ...mapGetters('ovp', {
                /** @type {boolean|*} */
                isActiveRequest: ovpStoreTypes.GET_IS_ACTIVE_REQUEST,
            }),
            ...mapGetters('company', {
                /** @type {Company|*} */
                currentCompany: companyStoreTypes.GET_CURRENT_COMPANY,
            }),
        },
        methods: {
            ...mapMutations({
                /** @type {function|*} */
                setAlertData: rootStoreTypes.SET_ALERT_DATA,
            }),
           ...mapActions('ovp', {
                /** @type {function|*} */
                approveUserOvpJobConditions: ovpStoreTypes.ACTION_APPROVE_OVP_JOB_CONDITIONS,
            }),
            async submit() {
                const isValid = await this.$refs.observer.validate();

                if (!isValid) {
                    return;
                }

                try {
                    const data = {
                        ovpJobConditions: this.ovps,
                        companyId: this.currentCompany._id,
                    };

                    await this.approveUserOvpJobConditions(data);

                    this.reset();
                } catch (error) {
                    this.$refs.observer.setErrors({[error.field]: [error.message]});
                }
            },
            updateStatus(message) {
                this.setAlertData({type: 'primary', message});
                this.$emit('finished');
            },
            reset() {
                this.$refs.observer.reset();
                this.updateStatus('Ovp darba apstkļi apstiprināti!');
                this.ovps = [];
            },
            getNextInspectionDate(ctx, ovp) {
                const newDate = new Date(ctx.activeDate);
                newDate.setFullYear(ctx.activeDate.getFullYear() + (+ovp.ovpJobCondition.period))

                return new Date(newDate);
            }
        }
    }
</script>